import { Component, Input, Output, EventEmitter, ViewEncapsulation } from "@angular/core";

@Component({
    selector: 'notification-list',
    templateUrl: 'notification-list.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class NotificationListComponent {

  @Input() filteredNotifications: any[] = [];
  @Input() totalNotifications: number = 0;
  @Input() loaded: boolean = false;
  @Input() showExamples: boolean = false;
  @Input() showKeys: boolean = false;
  @Input() examples: any[] = [];
  @Input() errorMessage: string = '';

  @Output() loadMore = new EventEmitter<any>();
  @Output() notificationClick = new EventEmitter<any>();
  @Output() toggleKeys = new EventEmitter<boolean>();

  constructor() {}

  onLoadMore(event: any) {
    this.loadMore.emit(event);
  }

  onNotificationClick(notification: any) {
    this.notificationClick.emit(notification);
  }

  onToggleKeys() {
    this.toggleKeys.emit(!this.showKeys);
  }

  hasNotificationAction(notification: any) {
    return notification?.page_data?.name !== 'no_page' && notification?.page_data?.data?.chat_room_type !== 'concierge_customer';
  }

  parseNotificationTitle(title: string): string {
    if (!title) return '';

    // Check if title starts with "notification from"
    const notificationFromPattern = /^notification from\s+(.+?):\s*(.+)$/is;
    const match = title.match(notificationFromPattern);
    if (match) {
      const [, source, content] = match;
      // Replace newlines in content with <br/> tags
      const formattedContent = content.trim().replace(/\n/g, '<br/>');
      return `Notification from ${source.trim()}:<br/>${formattedContent}`;
    }
    return title;
  }
}
